const actionTypeIdentifier = "AB7C77AF-6198-4DC5-9D71-B4BE2B641Z8G";

export const setPlanCatalogueHistoryLogsLoading = `SET-PLAN-CATALOGUE-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getPlanCatalogueHistoryLogs = `GET-PLAN-CATALOGUE-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setPlanCatalogueHistoryPageSize = `SET-PLAN-CATALOGUE-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetPlanCatalogueHistory = `RESET-PLAN-CATALOGUE-HISTORY-${actionTypeIdentifier}`;
export const setPlanCatalogueColSearchStr = `SET-PLAN-CATALOGUE-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;